import React from 'react';
import { ChevronDownSmall } from '@wix/wix-ui-icons-common/on-stage';
import { IconButton } from '@wix/wix-ui-tpa/cssVars';

interface ArrowDownProps {
  className?: string;
  containerClassName?: string;
  dataHook?: string;
  open: boolean;
}

export const CollapsibleState: React.FC<ArrowDownProps> = ({ className, dataHook, open, containerClassName }) => {
  return (
    <div className={containerClassName}>
      <IconButton
        fullWidth={true}
        data-hook={dataHook}
        className={className}
        aria-label={open ? 'collapse' : 'expand'}
        aria-expanded={open}
        icon={<ChevronDownSmall fillOpacity="0.6" />}
      />
    </div>
  );
};
